import { Button, Heading, Paragraph, Popup, TriangleExclamationIcon } from '@quickmd-llc/design-system'

type FinishLaterModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirmClose: () => void
}
export const FinishLaterModal: React.FC<FinishLaterModalProps> = ({
  isOpen,
  onClose,
  onConfirmClose,
}: FinishLaterModalProps) => (
  <Popup
    onClose={onClose}
    isOpen={isOpen}
    showCloseIcon
    styles={{ containerClassName: 'w-[512px]' }}
    header={{
      content: (
        <Heading level='h3' className='flex items-center gap-sp-1'>
          <TriangleExclamationIcon iconSize='l' /> This visit is incomplete
        </Heading>
      ),
    }}
    body={
      <div className='w-full max-w-md rounded-lg bg-white'>
        <Paragraph className='text-text-medium'>
          Visits that were started but not marked &lsquo;Complete&rsquo; or &lsquo;Unresolved&rsquo; will be listed
          under &lsquo;Incomplete&rsquo; on your home screen.
        </Paragraph>
      </div>
    }
    footer={
      <div className='flex justify-end'>
        <Button priority='primary' onClick={onConfirmClose}>
          Go to home screen
        </Button>
      </div>
    }
  />
)
